<template>
  <div class="min-h-screen flex flex-row space-x-4 bg-gray-100">
    <!-- Sidebar for Management -->
    <aside class="bg-white sm:p-6 lg:p-8">
      <h2 class="text-lg font-bold mb-4">Management</h2>
      <ul class="space-y-2">
        <li v-for="m in managementItems" :key="m.id">
          <button @click="selectManagement(m.name)"
            class="w-full text-left px-4 py-2 rounded-lg hover:bg-green hover:text-gray-200 text-gray-800">
            {{ m.name }}
          </button>
        </li>
      </ul>
    </aside>

   <!-- Main Content Area -->
<div class="flex-1 flex flex-col items-center justify-center sm:p-6 lg:p-8 h-full">
  <component :is="currentComponent" class="w-full h-full"/>
</div>

    
  </div>
</template>


<script>
import { io } from 'socket.io-client';
import { mapActions, mapState } from 'vuex';
import ManageItems from './items/ManageItems.vue';
import ManageOrders from './orders/ManageOrders.vue'
import ManageDeliveries from './deliveries/ManageDeliveries.vue'
import ManageClients from './clients/ManageClients.vue'
import ManageStaffs from './staffs/ManageStaffs.vue'
import ManageCategories from './categories/ManageCategories.vue';
import LoadingView from '@/components/LoadingView.vue';
import { apiUrl } from '@/constants';

export default {
  data() {
    return {
      loadingComponent : 'LoadingView',
      currentComponent: 'ManageItems',
      itemOrder: {},
      socket: null,
    };
  },
  async mounted() {
    await this.fetchCategories();
    await this.fetchItems();

    this.initializeSocket();
  },
  computed: {
    ...mapState({
      managementItems: state => state.managementItems,
      isLoading : state => state.loading,
    }),
    ...mapState('orders', {
      order: state => state.orders.items.length,
      orders: state => state.orders,
    }),
    ...mapState('items', {
      items: state => state.items,
      categories: state => state.categories,
    }),
    totalOrderValue() {
      return this.orders.items.reduce((total, currentItem) => {
        const price = +currentItem.price * +currentItem.quantity || 0;
        return total + price;
      }, 0);
    }
  },
  methods: {
    ...mapActions('items', { fetchItems: 'fetchItems', fetchCategories: 'fetchCategories' }),
    ...mapActions('orders', { addItemToOrder: 'addItemToOrder' }),
    selectManagement(name) {
      
      if(name === 'Categories'){
        this.currentComponent = 'ManageCategories';
      }
      else if (name === 'Items') {
        this.currentComponent = 'ManageItems';
      } else if (name === 'Orders') {
        this.currentComponent = 'ManageOrders';
      }
      else if (name === 'Deliveries') {
        this.currentComponent = 'ManageDeliveries';
      }
      else if (name === 'Clients') {
        this.currentComponent = 'ManageClients';
      }
      else if (name === 'Staffs') {
        this.currentComponent = 'ManageStaffs';
      }
      // Map the management item to the respective component name
    },

    initializeSocket() {
      this.socket = io(apiUrl);
     
      this.socket.on('itemUpdated', (updatedItem) => {
        const index = this.items.findIndex(item => item.id === updatedItem.id);
        if (index !== -1) {
          this.items.splice(index, 1, updatedItem);
        } else {
          this.items.push(updatedItem);
        }
      });

      this.socket.on('itemDeleted', (deletedItemId) => {
        this.items = this.items.filter(item => item.id !== deletedItemId);
      });

      this.socket.on('orderPlaced', (order) => {
        alert(`Order placed for ${order.item.name} (${order.quantity} ${order.item.unit})`);
      });
    },
    scrollToCategory() {

    },
    placeOrder(item, quantity) {
      if (quantity <= 0) {
        alert('Please enter a valid quantity');
        return;
      }
      item.quantity = quantity;
      this.quantity = null;
      this.addItemToOrder(item);
      this.$store.state.items.items = this.$store.state.items.items.filter(i => i.id !== item.id);
    },
    goToOrderDetails() {
      this.$router.push('/orderdetails');
    }
  },
  components : {
    ManageItems,
    ManageOrders,
    ManageDeliveries,
    ManageClients,
    ManageStaffs,
    ManageCategories,
    LoadingView
  }
};
</script>
